import React, { Component } from "react";
import Icon from './Icon'
import {
    setCookie,
    getCookie,
    eraseCookie,
    setLocalStorage,
    getLocalStorage,
  } from "../global/browserFunctions";
  import { cartUrl } from "../global/url";
  import {showNotification} from "../global/notification";
  import jquery from "jquery";

class MainIcons extends Component{

    constructor(props){
        super(props);

        this.state={
            cartCount: 0
        }
        this.signOut = this.signOut.bind(this);
        this.setCartCount = this.setCartCount.bind(this);
    }

    componentDidMount(){
      this.setCartCount();
    }


    setCartCount(){
      var query="&method=fetch&customer=";
      var customer=getCookie("customid");
      query+=customer;
      var self=this;
      jquery
      .ajax({
        url: cartUrl + query,
        Cache: false,
        dataType: "jsonp",
      }).done(function (data) {
       try {
        data=JSON.parse(decodeURIComponent(data));
        if(data.summary && data.summary.status=="SUCCESS")
        {
          var qty=0;
          var items=data.summary.data;
          for(var i in items)
          {
            var itemQty=items[i].itemQuantity || 0;
            qty+=itemQty;
          }
          setCookie('cartCount', qty)
          self.setState({cartCount: qty});
        }
        else
        {
          setCookie('cartCount', 0)
        }
       } catch (error) {
         console.log("err@fectchcart", error)
       }
      }).fail(function() {
        showNotification(
          "Sorry",
          "danger",
          "An unknown error occurred. Couldn't fetch cart info"
        );
      })
    }

    signOut(isSignout){
        if(isSignout){
            eraseCookie('log');
            eraseCookie('name');
           if(this.props.history)
          this.props.history.push('/') ;
          localStorage.clear();
          sessionStorage.clear();
        }
    }

    render(){
        return(
            <React.Fragment>
            <ul className={`list-inline mb-0 ${this.props.className}`}>
                <li className="list-inline-item mr-3">
                    <a className={`text-${this.props.light ? 'light' : 'dark'} text-hover-primary`} href="/orders" title={this.props.accountName}>
                        <Icon icon="avatar-1" className="navbar-icon" title={this.props.accountName}/>
                    </a>
                </li>
                <li className="list-inline-item position-relative mr-3">
                    <a className={`text-${this.props.light ? 'light' : 'dark'} text-hover-primary`} href="/cart" title="Cart">
                        <Icon icon="retail-bag-1" className="navbar-icon" />
                        <div className="navbar-icon-badge">{this.state.cartCount}</div>
                    </a>
                </li>
                <li className="list-inline-item position-relative mr-3 Log-Out">
                    <a className={`text-${this.props.light ? 'light' : 'dark'} text-hover-primary`} href="#" title="Sign out" onClick={()=>this.signOut(true)}>
                        <Icon icon="exit-1" className="navbar-icon" />
                        {/* <div className="navbar-icon-badge"></div> */}
                    </a>
                </li>
            </ul>

        </React.Fragment>
        )
    }
}

export default MainIcons;
